import { get, omit } from 'lodash';

export const getInvoices = state => get(state, 'invoices.queryResult.data', []);
export const getInvoicePagination = state => omit(getInvoices(state), 'data');
